import { mapGetters } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import Contract from '@/models/contract';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    hideOrdersLabel: {
      type: Boolean,
      default: false,
    },
    showZeroOrders: {
      type: Boolean,
      default: false,
    },
    symbol: {
      type: String,
      default: '&cent;',
    },
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    contractModel() {
      return new Contract(this.contract);
    },
    classModifiers() {
      return {
        'market-ownership-and-orders-bar': true,
        [`market-ownership-and-orders-bar--${this.theme}`]: this.theme,
        'market-ownership-and-orders-bar--yes': this.contractModel.mode === 'yes',
        'market-ownership-and-orders-bar--no': this.contractModel.mode === 'no',
        'market-ownership-and-orders-bar--mobile': this.isLayoutMobile,
        'market-ownership-and-orders-bar--without-orders': !this.hasOrders,
        'market-ownership-and-orders-bar--without-ownership': !this.hasOwnership,
      };
    },
    ownershipClassModifiers() {
      return {
        'market-ownership-and-orders-bar__ownership--yes': this.contractModel.mode === 'yes',
        'market-ownership-and-orders-bar__ownership--no': this.contractModel.mode === 'no',
      };
    },
    hasOwnership() {
      return this.contractModel.userQuantity > 0;
    },
    hasOrders() {
      return this.contractModel.userOpenOrders > 0;
    },
    showOrdersSummary() {
      return this.hasOrders || this.hasOwnership;
    },
    shouldRender() {
      return this.hasOwnership || this.hasOrders;
    },
    showOwnershipIcon() {
      return this.hasOwnership;
    },
    ownershipQuantityDisplay() {
      return Number(this.contractModel.userQuantity || 0).toLocaleString('en-US');
    },
    ownershipModeDisplay() {
      return this.contractModel.mode.toUpperCase();
    },
    ownershipAverage() {
      return this.contractModel.userAveragePricePerShareAsCents;
    },
    ownershipDifference() {
      return this.contractModel.userChangePriceAsCents;
    },
    buyOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersBuyQuantity || 0).toLocaleString('en-US');
    },
    sellOrdersDisplay() {
      return Number(this.contractModel.userOpenOrdersSellQuantity || 0).toLocaleString('en-US');
    },
  },
};
